import { Component, OnInit, Input } from '@angular/core';

import { vehiclePanelOptions } from 'src/app/vehicles/models/vehicle-panel-option';
import { VehicleDisplay, VehiclePanelOption, showVehicleButton } from 'src/app/shared/models/configuration';
import { StateCustomPanelVehicleService } from 'src/app/vehicles/components/content-panel-vehicles/service/state-custom-panel-vehicle.service';
import { VehicleConfigService } from 'src/app/vehicles/services/vehicle-config.service';
import { configSections } from 'src/app/profile-config/services/user-config-panel.service';

@Component({
  selector: 'app-user-vehicle-config',
  templateUrl: './user-vehicle-config.component.html',
  styleUrls: ['./user-vehicle-config.component.scss', './../components-conf.scss']
})
export class UserVehicleConfigComponent implements OnInit {
  @Input() filterOptionsBy : string = ""

  public configSections = configSections;

  public vehicleOptions = [
    { id: 'verImei', name: 'IMEI', description: 'Mostrar u ocultar el IMEI en la tarjeta del vehículo' },
    { id: 'numSim', name: 'Número SIM', description: 'Mostrar u ocultar el número de SIM en la tarjeta' },
    { id: 'verColor', name: 'Estado de transmisión', description: 'Indica si la transmisión está activa o inactiva' },
    { id: 'verIgnition', name: 'Estado de ignición', description: 'Muestra si el vehículo está encendido o apagado' },
    { id: 'verSpeed', name: 'Velocidad', description: 'Visualiza la velocidad actual del vehículo' },
    { id: 'verBaterryVoltage', name: 'Voltaje de batería', description: 'Muestra el nivel de voltaje de la batería' },
    { id: 'verAmountOfFuel', name: 'Combustible', description: 'Indica la cantidad de combustible disponible' },
    { id: 'verTimeElapsed', name: 'Tiempo transcurrido', description: 'Tiempo desde que comenzó el viaje o registro' },
    { id: 'verSatellite', name: 'Cantidad de satélites', description: 'Número de satélites conectados al GPS' },
    { id: 'verIconVehicle', name: 'Ícono del vehículo', description: 'Muestra u oculta el ícono representativo del vehículo' },
    { id: 'verTemperaturaBle', name: 'Temperatura BLE', description: 'Muestra u oculta el ícono representativo del vehículo' },
    { id: 'verTemperaturaEye', name: 'Temperatura EYE', description: 'Muestra u oculta el ícono representativo del vehículo' },
    { id: 'verHumedadBle', name: 'Humedad BLE', description: 'Muestra u oculta el ícono representativo del vehículo' },
    { id: 'verHumedadEye', name: 'Humedad EYE', description: 'Muestra u oculta el ícono representativo del vehículo' },
    { id: 'ver', name: 'Control de visualización de puntos de vehículos', description: 'Permite mostrar u ocultar controles de visualización' },
    { id: 'verTransmissionStatus', name: 'Filtrado por estado de transmisión', description: 'Filtra los vehículos según su estado de transmisión' },
    { id: 'verDriver', name: 'Botón de conductor', description: 'Mostrar u ocultar el botón de información del conductor' },
    { id: 'verName', name: 'Botón de nombre', description: 'Mostrar u ocultar el nombre del vehículo o conductor' },
    { id: 'verFollowUnit', name: 'Botón de seguir vehículo', description: 'Permite activar el seguimiento del vehículo' },
    { id: 'verEye', name: 'Botón de visualización', description: 'Mostrar u ocultar opciones de visualización adicionales' },
  ];

  public vehicleOptionConfig : VehiclePanelOption = vehiclePanelOptions;
  public vehicleDisplayConfig! : VehicleDisplay;

  public showIcons = true;
  public configVehicleButtonOptions: showVehicleButton;

  constructor(
    private panelService : StateCustomPanelVehicleService,
    public vehicleConfigService : VehicleConfigService
  ) {
    this.configVehicleButtonOptions = this.vehicleConfigService.valueSelectButtonSubject.getValue();
    this.vehicleDisplayConfig = this.vehicleConfigService.vehicleDisplaySubject.getValue()
  }

  ngOnInit(): void {
    this.panelService.optionConfiguration$.subscribe((configuration)=>{
      this.vehicleOptionConfig = configuration
    })
    this.vehicleConfigService.vehicleDisplay$.subscribe((config)=>{
      this.vehicleDisplayConfig = config;
    })
    this.vehicleConfigService.valueSelectButton$.subscribe((config)=>{
      this.configVehicleButtonOptions = config
    })
  }

  toggleEnabled(id: string, value: boolean) {
    this.vehicleOptionConfig[id].enabled = value;
    this.panelService.setOptionConfiguration(this.vehicleOptionConfig)
  }

  toggleVisible(id: string, value: boolean) {
    this.vehicleOptionConfig[id].visible = value;
    this.panelService.setOptionConfiguration(this.vehicleOptionConfig)
  }

  toggleDisplayVisible() {
    this.vehicleConfigService.setVehicleDisplayConfig();
  }

  toggleShowIcons(){
    this.vehicleConfigService.setShowIconTransmission()
  }

  toggleShowVehicleButton(value : boolean) {
    this.configVehicleButtonOptions.showOptions = value;
    this.vehicleConfigService.setSelectedButton(this.configVehicleButtonOptions)
  }


}
